<template>
	<section class="app-container bg--secondary">
		<div class="container">
			<div v-if="!is_reset">
				<h1>Reset Your Password</h1>
				  <div class="row">
				  	<div class="col-md-6">
				  		<label>New Password:</label>
						<input type="password" v-model="password" />
		                <error-list v-bind:errors="error_results.new_password"></error-list>
				  		<label>Confirm Password:</label>
						<input type="password" v-model="passwordConfirmed" />
		                <error-list v-bind:errors="error_results.re_new_password"></error-list>
		                <error-list v-bind:errors="error_results.non_field_errors"></error-list>
		                <error-list v-bind:errors="error_results.token"></error-list>
		                <error-list v-bind:errors="error_results.uid"></error-list>
						<button @click="savePassword()" class="btn btn-primary btn-block">Save</button>
				  	</div>
				  </div>
			</div>
			<div v-else class="alert alert-info">
				<strong>Your password has been reset.</strong><br />
				Please login now.
			</div>
		  
		</div>
	</section>
</template>

<script>
export default {
	name: 'RecoverPassword',
	metaInfo: {
      title: 'Password Recovery',
    },
	data: function(){
		return {
			password: null,
			passwordConfirmed: null,
			error_results: [],
			is_reset:false,
		};
	},
	mounted(){
	},
	methods:{
		savePassword: function(){
			if (!this.password || !this.passwordConfirmed) {
				self.$notify({
                    title: 'Please enter and confirm your password.',
                    type: 'error',
                });
                return;
			}

			var self = this;
			this.API({
                endpoint: 'auth/users/reset_password_confirm',
                funcThen: function(response){
                	self.is_reset = true;
                },
                funcCatch: function(error){
                    if (error.response && error.response.data) {
                        self.error_results = error.response.data;
                    }
                    else{
                        console.log(error);
                    }
                },
                isPost:true,
                postData: { 
                	uid: self.$route.params.uid,
					token: self.$route.params.token,
					new_password: self.password,
					re_new_password: self.passwordConfirmed
                }
            });
		},
	},
}
</script>


// WEBPACK FOOTER //
// src/components/pages/RecoverPasswordView.vue